import { render } from "./ScheduledDispatchDetails.vue?vue&type=template&id=4d1dc6e5&scoped=true"
import script from "./ScheduledDispatchDetails.vue?vue&type=script&lang=js"
export * from "./ScheduledDispatchDetails.vue?vue&type=script&lang=js"

import "./ScheduledDispatchDetails.vue?vue&type=style&index=0&id=4d1dc6e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1dc6e5"]])

export default __exports__